import { useEffect, useRef, useState } from "react";
import { AUTH_CHANGED_EVENTS, getToken } from "../lib/auth";

/** Remount private editors when authentication changes, including another tab. */
export function useAuthScopeEpoch(): number {
    const token = useRef(getToken());
    const [epoch, setEpoch] = useState(0);
    useEffect(() => {
        const update = () => {
            const current = getToken();
            if (current !== token.current) {
                token.current = current;
                setEpoch(value => value + 1);
            }
        };
        for (const event of AUTH_CHANGED_EVENTS) window.addEventListener(event, update);
        window.addEventListener("storage", update);
        update();
        return () => {
            for (const event of AUTH_CHANGED_EVENTS) window.removeEventListener(event, update);
            window.removeEventListener("storage", update);
        };
    }, []);
    return epoch;
}
